import { OrganizationDetailsBranchModel } from './organization-details-branch-model';

export class OrgProfileModal {
  accountHolderName: string;
  accountNumber: number;
  additionalNameForInvoice: string;
  authorisedSignatury: string;
  bankName: string;
  billingAddress: string;
  branchName: string;
  companyName: string;
  footerNote: string;
  footerSign: string;
  qrCode: string;
  footerLogo: string;
  gstin: string;
  headerLogo: string;
  id: number;
  ifscCode: string;
  cinNo: string;
  pan: string;
  shippingAddress: string;
  phoneNo: number;
  mobileNo: number;
  email: string;
  secondryMobileNo:string;
  secondaryEmail: string;
  secondaryMobileNo: number;
  party: number; //NULL -> Self Organization, NOTNULL -> Party Organization
  partyName: string; //NULL -> Self Organization, NOTNULL -> Party Organization
  branchDetails: Array<OrganizationDetailsBranchModel>;
  isForcefullySetDefault = false; //Set to True from UI When user accept confirmationBox(In case where other organization is already set as default).
  isDefault = false; //Set True 1 per Partner(For displaying default Org on click of 'OrgProfile'
  isDefaultOrg: string;
  moduleName: string;
}
